<div>
  <!--  <div class="appUrl">app from: {{content?.url}}</div>-->
  @if (content?.url) {
    <app-app-and-lab [content]="content"></app-app-and-lab>
  }
</div>
